import { render, staticRenderFns } from "./SectionSeverityFrom2023.vue?vue&type=template&id=49364a2c"
import script from "./SectionSeverityFrom2023.vue?vue&type=script&lang=ts"
export * from "./SectionSeverityFrom2023.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports